// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const LIST_OF_GROUPS_SHOW_MORE = "Uk\u00e1\u017e viac";
export const LOAD_FEED_NEWEST = "Prejdi na najnov\u0161ie pr\u00edspevky";
